export interface MinecraftTextPart {
  text: string;
  color?: string;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  strike?: boolean;
}

const MINECRAFT_COLORS: Record<string, string> = {
  '0': '#000000',
  '1': '#0000AA',
  '2': '#00AA00',
  '3': '#00AAAA',
  '4': '#AA0000',
  '5': '#AA00AA',
  '6': '#FFAA00',
  '7': '#AAAAAA',
  '8': '#555555',
  '9': '#5555FF',
  a: '#55FF55',
  b: '#55FFFF',
  c: '#FF5555',
  d: '#FF55FF',
  e: '#FFFF55',
  f: '#FFFFFF',
};

export const normalizeMinecraftText = (value: string) =>
  value.replace(/Â(?=§)/g, '').replace(/Â§/g, '§');

export const parseMinecraftText = (rawText: string): MinecraftTextPart[] => {
  const text = normalizeMinecraftText(rawText);
  const parts: MinecraftTextPart[] = [];
  let buffer = '';
  let color: string | undefined;
  let bold = false;
  let italic = false;
  let underline = false;
  let strike = false;

  const pushBuffer = () => {
    if (!buffer) {
      return;
    }
    parts.push({
      text: buffer,
      color,
      bold,
      italic,
      underline,
      strike,
    });
    buffer = '';
  };

  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    const nextChar = text[i + 1]?.toLowerCase();

    if (char === '§' && nextChar) {
      pushBuffer();
      i += 1;

      if (nextChar in MINECRAFT_COLORS) {
        color = MINECRAFT_COLORS[nextChar];
        bold = false;
        italic = false;
        underline = false;
        strike = false;
        continue;
      }
      if (nextChar === 'l') {
        bold = true;
        continue;
      }
      if (nextChar === 'o') {
        italic = true;
        continue;
      }
      if (nextChar === 'n') {
        underline = true;
        continue;
      }
      if (nextChar === 'm') {
        strike = true;
        continue;
      }
      if (nextChar === 'r') {
        color = undefined;
        bold = false;
        italic = false;
        underline = false;
        strike = false;
      }
      continue;
    }

    buffer += char;
  }

  pushBuffer();

  if (parts.length === 0 && text) {
    return [{ text }];
  }

  return parts;
};
